import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MenuService } from 'ahm-angular';
import { MENU } from 'src/config/menu';
import { environment } from 'src/environments/environment';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = MENU.title;
  env = "local";

  constructor(
    private _menu: MenuService,
    private _titleService: Title,
    private primeNGConfig: PrimeNGConfig) {
    this.env = environment.environment;
    this._titleService.setTitle(MENU.title);
    _menu.setMenu(MENU);
  }


  ngOnInit() {
    this.primeNGConfig.setTranslation({
      "startsWith": "Starts with",
      "contains": "Contains",
      "notContains": "Not contains",
      "endsWith": "Ends with",
      "equals": "Equals",
      "notEquals": "Not equals",
      "noFilter": "No Filter",
      "lt": "Less than",
      "lte": "Less than or equal to",
      "gt": "Greater than",
      "gte": "Greater than or equal to",
      "is": "Is",
      "isNot": "Is not",
      "before": "Before",
      "after": "After",
      "dateIs": "Date is",
      "dateIsNot": "Date is not",
      "dateBefore": "Date is before",
      "dateAfter": "Date is after",
      "clear": "Limpiar",
      "apply": "Apply",
      "matchAll": "Match All",
      "matchAny": "Match Any",
      "addRule": "Add Rule",
      "removeRule": "Remove Rule",
      "accept": "Yes",
      "reject": "No",
      "choose": "Choose",
      "upload": "Upload",
      "cancel": "Cancel",
      "dayNames": ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
      "dayNamesShort": ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      "dayNamesMin": ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      "monthNames": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      "monthNamesShort": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      "dateFormat": "dd/mm/yy",
      "firstDayOfWeek": 1,
      "today": "Hoy",
      "weekHeader": "Sm",
      "weak": "Semana",
      "medium": "Medio",
      "strong": "Fuerte",
      "passwordPrompt": "Ingrese una contraseña",
      "emptyMessage": "No se encontrarón resultados",
      "emptyFilterMessage": "Filtro vacío",
    });
  }
}